<template>
  <div class="venueScoreStatus">
    <button
      class="venueScoreStatusButton"
      :class="scoreClass"
      :title="title"
      @click="onClick"
    >
      {{ displayScore }}
    </button>
    <b-icon
      v-if="isIgnored"
      icon="dash"
      class="checkIcon"
      :class="scoreClass"
      @click.stop="onClick"
    />
    <b-icon
      v-else-if="isFinished"
      icon="check"
      class="checkIcon"
      :class="scoreClass"
      @click.stop="onClick"
    />
    <span
      v-else
      class="checkPlaceholder"
    />
    <b-icon
      v-if="hasVenueWineId"
      icon="chevron-right"
      class="chevronIcon"
      @click.stop="onClick"
    />
  </div>
</template>

<script>
import { isFinishedUpdaterStatus, isIgnoredUpdaterStatus } from '@/utils/sheetRowFunctions'
export default {
  name: 'VenueScoreStatusButton',
  props: {
    score: {
      type: [Number, String],
      default: null,
    },
    venueWineId: {
      type: [Number, String],
      default: null,
    },
    updaterStatus: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasScore() {
      return this.score != null && this.score !== ''
    },
    hasVenueWineId() {
      return this.venueWineId != null && this.venueWineId !== '' && this.venueWineId !== "n/a"
    },
    isFinished() {
      return isFinishedUpdaterStatus(this.updaterStatus);
    },
    isIgnored() {
      return isIgnoredUpdaterStatus(this.updaterStatus);
    },
    displayScore() {
      const s = Number(this.score)
      if (!this.hasVenueWineId) return s
      return Math.max(s || 0, 25)
    },
    scoreClass() {
      const s = this.displayScore
      if (s >= 150 || this.isFinished) return 'score-high'
      if (s >= 100 || this.hasVenueWineId) return 'score-medium'
      return 'score-low'
    },
    title() {
      return this.$t('receiptMatcher.venueScoreMatchTitle')
    },
  },
  methods: {
    onClick() {
      this.$emit('clicked', {
        venueWineId: this.venueWineId,
      })
    },
  },
}
</script>

<style scoped>
.venueScoreStatus {
  display: inline-flex;
  align-items: center;
  gap: var(--margin-xxs);
}
.venueScoreStatusButton {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid var(--color-primary-500);
  background: transparent;
  color: var(--color-white);
  font-size: 0.75rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}
.checkIcon {
  font-size: 1rem;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid var(--color-primary-500);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.checkPlaceholder {
  width: 28px;
  height: 28px;
  display: inline-block;
}
.chevronIcon {
  font-size: 1rem;
  cursor: pointer;
  margin-left: var(--margin-xs);
}
.score-high {
  border-color: var(--color-primary-500);
  color: var(--color-primary-500);
}
.score-medium {
  border-color: #f0ad4e;
  color: #f0ad4e;
}
.score-low {
  border-color: var(--color-danger);
  color: var(--color-danger);
}
</style>